import {IMacroDistributionResponse} from '../macronutrient-distribution';
import {IDistributionProperty} from '../interfaces/distribution-property.interface';

export class DistributionPropertyPercentage implements IDistributionProperty {
  type: 'grams' | 'percentage' | 'lts';
  block: boolean;
  response: IMacroDistributionResponse;
  grams: string;
  defaultValue: number;
  constructor(
    public title: string,
    public reference: {
      minimum: number,
      maximum?: number
    },
    public value: number,
    public icon: string
  ) {
    this.type = 'percentage';
    this.block = false;
    this.defaultValue = value;
  }
  setBlock(value: boolean): void {
    this.block = value;
  }

  verify(grams: number, total: number): void {
    this.grams = grams.toFixed(2);
    let gramsPercentage = 0;
    if (grams > 0) {
      gramsPercentage = Math.round((grams * 100) / total);
    }

    // Comparación con el valor elegido por el experto
    if (this.defaultValue > 0 && gramsPercentage > this.defaultValue) {
      this.response = {
        ...this.response,
        isHigher: true,
        messageChoiceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${gramsPercentage - this.defaultValue}% superior a la distribución elegida.`
      };
    } else if (this.defaultValue > 0 && gramsPercentage < this.defaultValue) {
      this.response = {
        ...this.response,
        isLower: true,
        messageChoiceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${this.defaultValue - gramsPercentage}% inferior a la distribución elegida.`
      };
    } else {
      this.response = {
        ...this.response,
        messageChoiceValue: undefined,
      };
    }

    if (this.value < this.reference.minimum) {
      this.response = {
        ...this.response,
        isLower: true,
        messageReferenceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${this.reference.minimum - this.value}% inferior a la referencia.`
      };
    } else if (this.reference.maximum ? this.value > this.reference.maximum : this.value > this.reference.minimum) {
      this.response = {
        ...this.response,
        isLower: true,
        messageReferenceValue: `El valor en gramos de ${this.title} equivale al ${gramsPercentage}% y es ${this.value - (this.reference.maximum || this.reference.minimum)}% superior a la referencia.`
      };
    } else {
      this.response = {
        ...this.response,
        messageReferenceValue: undefined,
      };
    }
  }




  getReference(): string {
    return this.reference.minimum + (this.reference.maximum ? ' - ' + this.reference.maximum : '');
  }

  setValue(value: number): void {
    this.value = value;
  }

  setDefaultValue(value: number): void {
    this.defaultValue = value;
  }

}
